<template>
  <div>
    <v-menu offset-y center>
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
      </template>
      <v-list>
        <v-list-item>
          <v-list-item-title
            :disabled="!$auth.policies['update-ownClass']"
            style="cursor: pointer"
            @click="editState = !editState"
            >Điều chỉnh phân công</v-list-item-title
          >
        </v-list-item>
        <v-list-item>
          <v-list-item-title
            :disabled="!$auth.policies['delete-ownClass']"
            style="cursor: pointer"
            class="elevation-0 red--text accent-1"
            @click="deleteState = true"
            >Xoá phân công</v-list-item-title
          >
        </v-list-item>
      </v-list>
    </v-menu>

    <OwnClassTeacherEditDialog
      :selectedTeacher="teacher"
      :ownClass="ownClass"
      :state="editState"
      @done="$emit('updateDone', ownClass)"
    />
    <OwnClassTeacherDeleteDialog :state="deleteState" @delete="onDelete" @closeDialog="deleteState = false" />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import OwnClassTeacherEditDialog from '@/modules/teacher/OwnClassTeacherEditDialog.vue'
import OwnClassTeacherDeleteDialog from '@/modules/teacher/OwnClassTeacherDeleteDialog'

export default {
  components: {
    OwnClassTeacherEditDialog,
    OwnClassTeacherDeleteDialog
  },
  props: {
    teacher: { type: Object, default: () => {} },
    ownClass: { type: Object, default: () => {} }
  },
  data() {
    return {
      sending: null,
      editState: false,
      deleteState: false
    }
  },
  methods: {
    ...mapActions('teaching', ['removeTeaching', 'updateTeaching']),
    ...mapActions('ownClassTeacher', ['updateClass', 'updateMessageGroup']),

    async onDelete() {
      try {
        this.$loading.active = true
        const index = this.ownClass.headTeachers.findIndex(t => t.id === this.teacher.id)
        this.ownClass.headTeachers.splice(index, 1)
        await this.updateClass(this.ownClass)
        // update header teacher => update message group
        await this.updateMessageGroup({
          classData: this.ownClass
        })
        this.$alert.success('Xoá thành công!')
        this.deleteState = false
        this.$emit('updateDone', this.ownClass)
      } catch (error) {
        console.error('err', error)
        this.$alert.updateError()
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
